/**
 * @generated SignedSource<<90a7f52870a6d7d1ed02eed7538ca652>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type serviceCreditsAddon_fragment$data = {
  readonly addon: {
    readonly addonID: number;
    readonly name: string;
    readonly rates: ReadonlyArray<{
      readonly feeValue: number;
      readonly rateID: number;
      readonly usageFrom: number;
    }>;
  } | null;
  readonly " $fragmentType": "serviceCreditsAddon_fragment";
};
export type serviceCreditsAddon_fragment$key = {
  readonly " $data"?: serviceCreditsAddon_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"serviceCreditsAddon_fragment">;
};

import serviceCredits_fragmentAddonQuery_graphql from './serviceCredits_fragmentAddonQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "addonKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currencyCode"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": serviceCredits_fragmentAddonQuery_graphql
    }
  },
  "name": "serviceCreditsAddon_fragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "addonKey",
          "variableName": "addonKey"
        },
        {
          "kind": "Variable",
          "name": "currencyCode",
          "variableName": "currencyCode"
        }
      ],
      "concreteType": "Addon",
      "kind": "LinkedField",
      "name": "addon",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "addonID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AddonRate",
          "kind": "LinkedField",
          "name": "rates",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "feeValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "usageFrom",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rateID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1d05f0741dd89db9861dd1e93858c71f";

export default node;
